import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Subject } from 'rxjs';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class CardService {

  cards = new Subject();

  constructor(private http: HttpClient) { }

  addCard(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/users/cards`, data);
  }

  setCards(cards) {
    this.cards.next(cards);
  }

  getCards() {
    return this.cards.asObservable();
  }

  removeCard(ID: string) {
    const data = new FormData();
    data.append('card', ID)
    return this.http.request<{ success: boolean, data: any }>('delete', `${apiURL}/users/cards`, { body: data });
  }
}
